import ApiDatabase from "../server";

export const fetchTimeCut = (companyId) => {
  return new Promise((resolve, reject) => {
    ApiDatabase.getTimeCut(
      { companyId },
      (res) => resolve(res),
      (err) => reject(err)
    );
  });
};

export const updateTimeCut = (newValue, companyId) => {
  return new Promise((resolve, reject) => {
    ApiDatabase.postUpdateTimeCut(
      { timeCut: newValue, companyId },
      (res) => resolve(res),
      (err) => reject(err)
    );
  });
};

export const fetchBreaks = (companyId) => {
  return new Promise((resolve, reject) => {
    ApiDatabase.getBreaks(
      { companyId },
      (res) => resolve(res),
      (err) => reject(err)
    );
  });
};

export const updateBreaks = (selectedBreak, companyId) => {
  return new Promise((resolve, reject) => {
    ApiDatabase.postUpdateBreaks(
      { breaks: selectedBreak, companyId },
      (res) => resolve(res),
      (err) => reject(err)
    );
  });
};

// Fetches whether PDNS display is enabled for the big company
export const fetchPdnsDisplay = (companyId) => {
  return new Promise((resolve, reject) => {
    ApiDatabase.getPdnsDisplay(
      { companyId },
      (res) => resolve(res),
      (err) => reject(err)
    );
  });
};

// Fetches list of companies with their PDNS status
export const fetchCompaniesPdns = (companyId) => {
  return new Promise((resolve, reject) => {
    ApiDatabase.getCompaniesPdns(
      { companyId },
      (res) => resolve(res),
      (err) => reject(err)
    );
  });
};

// Updates PDNS setting for a specific company
export const updateCompanyPdns = (idCompany, isPdns) => {
  return new Promise((resolve, reject) => {
    ApiDatabase.postUpdateCompanyPdns(
      { idCompany, isPdns },
      (res) => resolve(res),
      (err) => reject(err)
    );
  });
};

// Fetches whether Sunday Hours display is enabled for the big company
export const fetchSundayHoursDisplay = (companyId) => {
  return new Promise((resolve, reject) => {
    ApiDatabase.getSundayHoursDisplay(
      { companyId },
      (res) => resolve(res),
      (err) => reject(err)
    );
  });
};

// Fetches list of companies with their Sunday Hours status
export const fetchCompaniesSundayHours = (companyId) => {
  return new Promise((resolve, reject) => {
    ApiDatabase.getCompaniesSundayHours(
      { companyId },
      (res) => resolve(res),
      (err) => reject(err)
    );
  });
};

// Updates Sunday Hours setting for a specific company
export const updateCompanySundayHours = (idCompany, isSundayHours) => {
  return new Promise((resolve, reject) => {
    ApiDatabase.postUpdateCompanySundayHours(
      { idCompany, isSundayHours },
      (res) => resolve(res),
      (err) => reject(err)
    );
  });
};
